import { ResidentModel } from "app/services/api/types/residents/models/ResidentModel";

export const getFullName = (
  value:
    | { first_name?: string | null; last_name?: string | null }
    | undefined
    | null,
) => {
  const firstName = value?.first_name || "";
  const lastName = value?.last_name || "";
  return `${firstName} ${lastName}`.trim();
};

export const formatEnumText = (str: string) => {
  return str
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const formatTagText = (str: string) => {
  return str
    .toLowerCase()
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

/**
 * Formats the names of attending residents.
 * @param residents An array of ResidentModel objects or resident names (strings).
 * @param allResidents A boolean indicating whether all residents are attending.
 * @param isCalendarFormat A boolean indicating whether the residents array is in calendar format (string[]).
 * @returns A formatted string of resident names.
 */
export const formatAttendingResidents = (
  residents: ResidentModel[] | string[],
  allResidents?: boolean,
  isCalendarFormat: boolean = false,
): string => {
  if (allResidents) return "All residents";

  if (!residents || residents.length === 0) return "All residents";

  const residentName = isCalendarFormat
    ? (residents[0] as string)
    : getFullName(residents[0] as ResidentModel);
  const otherResidents = residents.length - 1;

  return otherResidents === 0
    ? residentName
    : `${residentName} and ${otherResidents} more`;
};
